// import React from 'react'
import { Tooltip } from "@material-tailwind/react";
import { socialMedia } from "../footer/Social";

const Social = () => {
  return (
    <section className="fixed xl:bottom-30 xl:left-3 2xl:bottom-60 2xl:left-7 hidden lg:flex flex-col gap-3 z-20">
      {socialMedia.map((Social) => (
        <a
          href={Social.link}
          key={Social.id}
          target={Social.target}
          className="rounded-full text-2xl bg-gray-600 bg-opacity-20 hover:bg-opacity-50 w-10 h-10 flex items-center justify-center animate-pulse"
        >
          <Tooltip content={Social.id} placement="right">
            <img src={Social.icon} className="p-2 " alt={Social.id} />
          </Tooltip>
        </a>
      ))}
    </section>
  );
};

export default Social;
